import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from 'antd';
import TrebbleConfigProvider from './ConfigProvider';

const TrebbleInfoTooltip = ({
    title,
    placement = 'top',
    className = '',
    style = {},
    marginLeft = 6,
    useEditorTheme = false,
    ...props
}) => {
    const defaultStyle = {
        marginLeft: marginLeft,
        cursor: 'pointer',
        outline: 'none',
        color: 'var(--text-default-color)',
        ...style
    };

    return (
        <TrebbleConfigProvider useEditorTheme={useEditorTheme}>
            <Tooltip title={title} placement={placement} {...props}>
                <span
                    className={`icon pe-7s-info text-lg ${className}`}
                    tabIndex={0}
                    aria-label={title}
                    role="button"
                    onKeyDown={(e) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                            e.preventDefault();
                            e.target.click();
                        }
                    }}
                    style={defaultStyle}
                />
            </Tooltip>
        </TrebbleConfigProvider>
    );
};

TrebbleInfoTooltip.propTypes = {
    title: PropTypes.string.isRequired,
    placement: PropTypes.oneOf(['top', 'left', 'right', 'bottom', 'topLeft', 'topRight', 'bottomLeft', 'bottomRight', 'leftTop', 'leftBottom', 'rightTop', 'rightBottom']),
    className: PropTypes.string,
    style: PropTypes.object,
    marginLeft: PropTypes.number,
    useEditorTheme: PropTypes.bool
};

export default TrebbleInfoTooltip; 